import { combineReducers, configureStore } from "@reduxjs/toolkit";
import ageVerificationReducer from "./ageVerification/ageVerificationSlice";
import appReducer from "./app/appSlice";
import characterReducer from "./character/characterSlice";
import chatDebugReducer from "./chatDebug/chatDebugSlice";
import cmsReducer from "./cms/cmsSlice";
import cloneConversationReducer from "./conversation/clone/cloneConversationSlice";
import conversationReducer from "./conversation/conversationSlice";
import { cookiesJar, localAsyncStorage, setAuthProvider, setCookiesJar, setLocalAsyncStorage, setReduxDispatch } from "./diProviders";
import myGalleryReducer from "./gallery/myGalleryPage/myGallerySlice";
import groupchatReducer from "./groupchat/groupchatSlice";
import lorebookReducer from "./lorebook/lorebookSlice";
import memoryReducer from "./memory/memorySlice";
import notificationReducer from "./notification/notificationSlice";
import rulebookReducer from "./rulebook/rulebookSlice";
import { userVoicesReducer } from "./tts/userVoices";
import { voiceReducer } from "./tts/voices";
import navigationReducer from "./user/navigationSlice";
import settingsReducer from "./user/settingsSlice";
import userInteractionsReducer from "./user/userInteractions/userInterractionsSlice";
import userPersistReducer from "./user/userPersist/userPersistSlice";
import { personaMiddleware } from "./user/userPersona/middlewares";
import userPersonaReducer from "./user/userPersona/personaSlice";
import userSettingsReducer from "./user/userSettings/userSettingsSlice";
import userReducer from "./user/userSlice";
import waitingQueueReducer from "./user/waitingQueueSlice";
import viewMediaModalReducer from "./viewMedia/viewMediaModal/viewMediaModalSlice";
import viewMediaPageReducer from "./viewMedia/viewMediaPage/viewMediaPageSlice";
const defaultReducers = {
    app: appReducer,
    character: characterReducer,
    chatDebug: chatDebugReducer,
    lorebook: lorebookReducer,
    rulebook: rulebookReducer,
    myGallery: myGalleryReducer,
    groupchat: groupchatReducer,
    memory: memoryReducer,
    cloneConversation: cloneConversationReducer,
    conversation: conversationReducer,
    userPersona: userPersonaReducer,
    userPersist: userPersistReducer,
    userInfo: userReducer,
    cms: cmsReducer,
    userSettings: userSettingsReducer,
    userInteractions: userInteractionsReducer,
    voices: voiceReducer,
    userVoices: userVoicesReducer,
    ageVerification: ageVerificationReducer,
    settings: settingsReducer,
    waitingQueue: waitingQueueReducer,
    navigation: navigationReducer,
    notification: notificationReducer,
    viewMediaModal: viewMediaModalReducer,
    viewMediaPage: viewMediaPageReducer,
};
export function setupStore(authProviderInstance, localStorageInstance, cookiesReader, middlewares = [], devTools = true, preloadedState = undefined, enhancers = undefined, reducer) {
    setLocalAsyncStorage(localStorageInstance);
    setCookiesJar(cookiesReader);
    setAuthProvider(authProviderInstance);
    if (!localAsyncStorage || !cookiesJar) {
        throw new Error("You haven't setup the store correctly, both the local storage and the cookie reader need to be set");
    }
    const store = configureStore({
        reducer: { ...defaultReducers, ...reducer },
        middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat([personaMiddleware, ...middlewares]),
        devTools,
        preloadedState,
        enhancers,
    });
    setReduxDispatch(store.dispatch);
    return store;
}
